import axios from 'axios';

const NOT_FOUND_STATUS = 404;

export default function isNotFoundError(error: Error): boolean {
  if (!axios.isAxiosError(error) || !error.response) return false;

  return error.response.status === NOT_FOUND_STATUS;
}
